/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import AWSAppSyncClient from 'aws-appsync';
import { DocumentNode } from 'graphql';
import { gql } from 'graphql-tag';
import { filter, map } from 'rxjs/operators';
import {
  UpdatePlantStatusType,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';
import { isNotNullOrUndefined } from '../../utils';

const build = (_query: DocumentNode, name = 'QueryResult') => {
  const bQuery = `
  subscription ${ name }{
    onPlantStatusUpdate{
      ...updateplantstatustype
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class OnPlantStatusUpdateSubscription {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment updateplantstatustype on UpdatePlantStatusType { ... }
   */
  execute(_query: DocumentNode) {
    return this.graphqlClient$.pipe(
      isNotNullOrUndefined(),
      map((client: AWSAppSyncClient<any>) =>
        client.subscribe<{ data : {  onPlantStatusUpdate : Partial<UpdatePlantStatusType>} }>({ query: build(_query) }),
      ),
    );
  }
}
